import React from "react"
import { isEmpty } from "lodash-es"
import { useAnsweredFormOverviewContext } from "contexts/AnsweredFormOverviewContext"
import AnsweredFormOverviewQuestions from "./AnsweredFormOverviewQuestions"

const AnsweredFormOverviewDeletedQuestions = () => {
  const { answeredDeletedQuestions, deletedQuestionsNote } = useAnsweredFormOverviewContext()

  if (isEmpty(answeredDeletedQuestions)) return null

  return (
    <>
      <div className="flex justify-center py-6 border-b border-lightgray-2 mb-8">
        <span>{deletedQuestionsNote}</span>
      </div>
      <AnsweredFormOverviewQuestions questions={answeredDeletedQuestions} />
    </>
  )
}

export default AnsweredFormOverviewDeletedQuestions
